import React, { useContext, useState } from "react";
import style from "./index.module.scss";
import { Button, Spin } from "antd";
import ListItem from "components/CourseComponents/SignIn/ListItem";
import useRequest from "utils/useRequest";

import {
    createPlain,
    getTeaSignIn,
    getTeaSignInList,
    SignInDetail
} from "service/signIn";
import ResultMessage from "components/CourseComponents/ResultMessage";
import { errorMessage, toNumber } from "service/service";
import SettingModal from "components/CourseComponents/SignIn/SettingModal";
import { useHistory } from "react-router-dom";
import qs from "qs";
import { CourseContext } from "../../../Store";
import CourseButton from "components/CourseComponents/CourseButton";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import { AiOutlineSync } from "react-icons/ai";
import { saveCourseSignRecord } from "../../../../../service/signIn";
import useRequestFn from "../../../../../utils/useRequestFn";

export default function SignLog() {
    const history = useHistory();

    const { course, basename } = useContext(CourseContext);
    const [data, { loading }, reload] = useRequest(
        () => getTeaSignInList(course.weekTimeId),
        {},
        [course.weekTimeId]
    );
    const [showModal, setShowModal] = useState(false);
    const [signInDetail, setSignInDetail] = useState<SignInDetail | null>(null);

    async function getSignInData(signInId: number) {
        try {
            const res = await getTeaSignIn(signInId);
            setSignInDetail(res);
            setShowModal(true);
        } catch (e) {
            ResultMessage.error(errorMessage(e, "获取活动信息失败！"));
        }
    }

    function addNewSignIn() {
        setSignInDetail(null);
        setShowModal(true);
    }

    const [createPlainAcion, { loading: createLoading }] =
        useRequestFn(createPlain);
    // 立即开始普通签到
    async function startPlainTask(signInId: number) {
        try {
            await createPlainAcion(signInId);
            gotoDetail(signInId);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    function gotoDetail(signInId: number, params?: StringMap) {
        const query = params ? `?${qs.stringify(params)}` : "";
        history.push(`${basename}/signInDetail/${signInId}${query}`);
    }

    return (
        <div className={style.root}>
            <div className={style.header}>
                <div className={style.count}>
                    签到活动（{data?.length || 0}）
                    <span className={style.tip}>
                        说明：直播的签到需在直播间发起，签到发起半小时后，签到结果数据会自动同步到当前签到活动列表。
                    </span>
                </div>

                <div className={style.buttons}>
                    <Button
                        onClick={() => saveCourseSignRecord(course.weekTimeId)}>
                        <AiOutlineSync size={20} /> 同步直播签到数据
                    </Button>
                    <CourseButton type="add" onClick={addNewSignIn}>
                        添加
                    </CourseButton>
                </div>
            </div>

            <Spin spinning={loading || createLoading}>
                {data?.map(item => (
                    <ListItem
                        key={item.id}
                        weekTimeId={course.weekTimeId}
                        basename={basename}
                        data={item}
                        onDelSuccess={reload}
                        onEdit={() => getSignInData(item.id)}
                        gotoDetail={gotoDetail}
                    />
                ))}

                {toNumber(data?.length) === 0 && (
                    <CustomEmpty style={{ padding: "100px 0" }} />
                )}
            </Spin>

            <SettingModal
                visible={showModal}
                onClose={() => setShowModal(false)}
                onStart={startPlainTask}
                onSuccess={reload}
                weekTimeId={course.weekTimeId}
                defaultData={signInDetail}
            />
        </div>
    );
}
